import * as stylex from '@stylexjs/stylex';
import { useEffect, type ReactNode } from 'react';
import { styles } from './styles';
type Props = {
  path: string;
  label: string;
  icon: ReactNode;
  rounded?: 'md' | 'lg';
};

// Floating action button — mobile only.
export function AppFab({
  path,
  label,
  icon,
  rounded = 'md'
}: Props) {
  return <button type="button" {...stylex.props(styles.fab, styles[rounded])} onClick={() => openApp(path)}>
      {icon}
      {label}
    </button>;
}

// Inline button. Visible everywhere by default; pass desktopOnly to hide it on
// mobile (for layouts that use the FAB there instead).
export function AppButton({
  path,
  label,
  icon,
  rounded = 'md',
  desktopOnly = false
}: Props & {
  desktopOnly?: boolean;
}) {
  return <button type="button" {...stylex.props(styles.inline, styles[rounded], desktopOnly && styles.hideMobile)} onClick={() => openApp(path)}>
      {icon}
      {label}
    </button>;
}

// ponytail: deep link only, no store fallback — the store listings aren't
// public yet. Restore the fallback redirect (in git history) at launch.
// The `tribys:/#/` form is the one the app's router rewrite expects —
// `tribys://path` would parse `path` as the URI host and never match a route.
export const appLink = (path: string) => `tribys:/#/${path}`;

// Matches no route in the app, which the router reads as "just come to the
// front" — it leaves whatever screen the user was on untouched.
export const OPEN_APP = appLink('open');
function openApp(path: string) {
  window.location.href = appLink(path);
}

// Shared pages try to pop the app open on arrival.
export function useOpenApp(path: string) {
  useEffect(() => openApp(path), [path]);
}